<template>
  <div v-bind="$attrs">
    <v-menu
      :attach="true"
      :close-on-content-click="closeAfterClick"
      content-class="dropdown-menu"
      data-cy="dropdownMenu"
    >
      <template v-slot:activator="{ props, isActive }">
        <v-btn
          v-bind="props"
          :class="activatorClassNames(isActive)"
          class="btn-activator"
          :prepend-icon="titleIcon"
          append-icon="mdi-chevron-down"
          elevation="0"
          data-cy="activatorButton"
        >
          {{ titleText }}
        </v-btn>
      </template>
      <v-list class="dropdown-options" data-cy="dropdownOptions">
        <v-list-item
          v-for="(item, i) in options"
          :key="i"
          :data-cy="`dropdownOption-${item.action}`"
          @click="selectOption(item.action)"
        >
          <template v-slot:prepend>
            <v-icon :icon="item.icon"></v-icon>
          </template>
          <v-list-item-title>
            <span>{{ item.text }}</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

export interface DropdownOption {
  text: string
  icon: string
  action: string
}

export default defineComponent({
  name: 'DropdownMenu',
  inheritAttrs: false,
  props: {
    titleText: {
      type: String,
      required: true
    },
    titleIcon: {
      type: String,
      required: false
    },
    options: {
      type: Array as PropType<DropdownOption[]>,
      required: true
    },
    onClickHandler: {
      type: Function as PropType<(action: string) => void>,
      required: false
    },
    closeAfterClick: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    activatorClassNames(isActive: boolean): string {
      return isActive ? 'bg-primary text-light is-active' : 'text-dark'
    },
    selectOption(action: string): void {
      if (typeof this.onClickHandler === 'function') {
        this.onClickHandler(action)
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.v-menu > :deep(.dropdown-menu) {
  border-radius: 0 0 4px 4px;
}
.btn-activator {
  --v-btn-height: 44px;
  transition: all 0.3s ease;

  :deep(.v-btn__append) {
    .v-icon.mdi-chevron-down {
      transform: rotate(0deg);
      transition: all 0.3s ease;
    }
  }

  &.is-active {
    border-radius: 4px 4px 0 0;

    :deep(.v-btn__append) {
      .v-icon.mdi-chevron-down {
        transform: rotate(-180deg);
      }
    }
  }
}
</style>
